import "./button-outline.scss";
import React, { forwardRef, useMemo, useState } from "react";
import variables from "../../styles/variables.scss";

const COLOR_MAP = {
  primary: "primary",
  secondary: "secondary",
  accent: "accent",
};

const ButtonOutline = forwardRef(function ButtonOutline(
  {
    text,
    color = "primary",
    reversed = false,
    disabled = false,
    large = false,
    wide = false,
    type = "button",
    className,
    children,
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur,
    onClick,
    ...rest
  },
  ref
) {
  const resolvedColor = useMemo(() => {
    const token = COLOR_MAP[color] ?? COLOR_MAP.primary;
    return variables[token] || variables.primary;
  }, [color]);

  const reversedActiveText = variables.gry6;

  const [active, setActive] = useState(false);
  const handleMouseEnter = (e) => {
    setActive(true);
    onMouseEnter?.(e);
  };
  const handleMouseLeave = (e) => {
    setActive(false);
    onMouseLeave?.(e);
  };
  const handleFocus = (e) => {
    setActive(true);
    onFocus?.(e);
  };
  const handleBlur = (e) => {
    setActive(false);
    onBlur?.(e);
  };

  const classes = [
    "button-outline",
    reversed && "reversed",
    disabled && "disabled",
    large && "large",
    wide && "wide",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const inlineStyle = disabled
    ? undefined
    : reversed
    ? {
        color: active ? reversedActiveText : variables.white,
        backgroundColor: active ? variables.white : "transparent",
      }
    : {
        backgroundColor: active ? resolvedColor : "transparent",
        color: active ? variables.white : resolvedColor,
        border: `3px solid ${resolvedColor}`,
      };

  return (
    <div
      ref={ref}
      type={type}
      disabled={disabled}
      className={classes}
      style={inlineStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onClick={onClick}
      {...rest}
    >
      {children ?? text}
    </div>
  );
});

export default ButtonOutline;
